import { UPDATE_USER_ERROR } from "./error-codes.constants";
import ApiError from "../../errors/ApiError";

export class DeleteUserError extends ApiError {
  constructor() {
    super(UPDATE_USER_ERROR);
  }
}
